<template>
  <div class="mobile">
    <div class="fullbox">
      <div class="goback">
        <div class="goback_box">
          <div @click="goback">
            <i class="el-icon-arrow-left"></i> <span>返回</span>
          </div>
          <div class="goback_search" v-if="showResult">
            <el-select
              v-model="valuePeople"
              placeholder="请选择"
              @change="changePeople"
            >
              <el-option
                v-for="item in optionPeople"
                :key="item.id"
                :label="item.evaluatorName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="user-mes">
          <div class="user">
            员工姓名：{{
              id ? obj.evaluatePersonnelName : userinfo.evaluatePersonnelName
            }}
          </div>
          <div class="mes" v-if="questions[currentIndex]?.questionType == 1">
            能力是指员工在日常工作中所展现的特质与技能的综合运用能力，以下问题有助于识别具有高能力的员工。
          </div>
          <div class="mes" v-if="questions[currentIndex]?.questionType == 2">
            抱负是指员工对于声誉与认可、晋升与影响力以及经济回报的渴望程度。以下问题有助于识别具有高抱负的员工。
          </div>
          <div class="mes" v-if="questions[currentIndex]?.questionType == 3">
            敬业度是指员工对组织的珍视、喜爱程度，以及他们相信留在组织符合自身最大利益的程度。以下问题有助于识别那些具有高敬业度的员工。
          </div>
        </div>
        <div class="quiz-container">
          <div class="title" v-if="questions[currentIndex]?.questionType == 1">
            能力评估问题清单
          </div>
          <div class="title" v-if="questions[currentIndex]?.questionType == 2">
            抱负评估问题清单
          </div>
          <div class="title" v-if="questions[currentIndex]?.questionType == 3">
            敬业度评估问题清单
          </div>
          <p class="msg">
            {{ currentIndex + 1 }}. {{ questions[currentIndex]?.question }}
          </p>

          <div
            v-for="(option, key) in questions[currentIndex]?.option"
            :key="key"
            :class="[
              'option',
              selectedAnswers[currentIndex]?.point == key ? 'selected' : '',
            ]"
            @click="selectAnswer(key, option)"
          >
            <span class="option-letter">{{
              key == 1
                ? "A"
                : key == 2
                ? "B"
                : key == 3
                ? "C"
                : key == 4
                ? "D"
                : "E"
            }}</span>
            <span class="option-shu"></span>
            <span class="option-text">{{ option }}</span>
            <img
              v-if="selectedAnswers[currentIndex]?.point == key"
              src="@/assets/evaluation/ok.png"
              class="check-icon"
            />
          </div>

          <div class="button-group">
            <el-button
              class="btn1"
              @click="prevQuestion"
              :disabled="currentIndex === 0"
            >
              上一题
            </el-button>
            <el-button
              class="btn2"
              @click="nextQuestion"
              :disabled="currentIndex == questions.length - 1"
              v-if="currentIndex < questions.length - 1"
            >
              下一题
            </el-button>
            <el-button
              class="btn2"
              @click="submit"
              :disabled="disabled"
              v-if="currentIndex == questions.length - 1 && !id && !showResult"
              >提交
            </el-button>
          </div>
        </div>
      </div>
      <div class="footer" v-if="showResult">
        <div class="btn">
          <el-button type="success" @click="toResult">转到结果</el-button>
        </div>
      </div>
      <div class="footer" v-if="!id && !showNext">
        <!-- <el-button class="btn1" @click="submit" :disabled="disabled"
          >提交</el-button
        > -->
        <el-button class="btn2" @click="next" :disabled="disabledNext"
          >考评下一个</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/evaluation";
export default {
  components: {},
  data() {
    return {
      disabled: false,
      userinfo: {},
      currentIndex: 0, // 当前题目索引
      selectedAnswers: [], // 存储用户选择的答案，包含题目、选项和选项文字
      questions: [],
      id: "",
      obj: {},
      disabledNext: true,
      showNext: true,
      showResult: false,
      valuePeople: "",
      optionPeople: [],
    };
  },
  mounted() {
    const { id, evaluatePersonnelCode } = this.$route.query;
    if (id) {
      this.id = id;
      this.getDetail(id);
      this.disabled = false;
    } else if (evaluatePersonnelCode) {
      this.showResult = true;
      this.getSelect();
    } else {
      this.userinfo = JSON.parse(sessionStorage.getItem("evaluationObject"));
      this.getList();
      this.getShowNext();
      this.disabled = true;
    }
  },
  methods: {
    // 转到结果
    toResult() {
      const { activityId, evaluatePersonnelCode } = this.$route.query;
      this.$router.push({
        path: "/evaluation/evaluationResult",
        query: {
          evaluatePersonnelCode: evaluatePersonnelCode,
          activityId: activityId,
        },
      });
    },
    // 获取考评人
    changePeople(val) {
      this.getDetail(val);
    },
    // 获取考评人
    getSelect() {
      const { evaluatePersonnelCode, activityId } = this.$route.query;
      api
        .evaluateManageList({
          page: 1,
          pageSize: 999,
          evaluatePersonnelCode: evaluatePersonnelCode,
          activityId: activityId,
        })
        .then((res) => {
          if (res.code == 200) {
            this.optionPeople = res.data.list;
            this.valuePeople = this.optionPeople[0].id;
            this.getDetail(this.optionPeople[0].id);
          }
        });
    },
    // 跳转
    toUrl(path) {
      this.$router.push(path);
    },
    // 返回
    goback() {
      // this.$router.go(-1);
      this.$router.push("/evaluation");
    },
    // 获取下一个
    getShowNext() {
      const obj = JSON.parse(sessionStorage.getItem("evaluationObject"));
      const params = {
        evaluatePersonnelCode: obj.evaluatePersonnelCode, // 考评对象工号
        evaluatorCode: obj.evaluatorCode, // 考评人工号
        activityId: obj.activityId, // 活动标题
      };
      api.queryPersonnel(params).then((res) => {
        if (res.code == 200) {
          console.log(res);
          this.showNext = res.data;
        }
      });
    },
    // 获取详情
    getDetail(id) {
      api.evaluateManageDetail({ id: id }).then((res) => {
        if (res.code == 200) {
          console.log(res, "1111111111111");
          this.obj = res.data;
          this.questions = res.data.answerList;
          const optionKeys = ["5", "4", "3", "2", "1"]; // ABC 选项
          this.questions.forEach((item) => {
            item.option = item.option.split(",").reduce((acc, text, index) => {
              acc[optionKeys[index]] = text;
              return acc;
            }, {});
            item.option = Object.fromEntries(
              Object.entries(item.option).reverse()
            );
          });
          this.selectedAnswers = this.questions;
        }
      });
    },
    // 获取列表
    getList() {
      api.evaluateQuestionsList().then((res) => {
        if (res.code == 200) {
          this.questions = res.data;
          const optionKeys = ["5", "4", "3", "2", "1"]; // ABC 选项
          this.questions.forEach((item) => {
            item.option = item.option.split(",").reduce((acc, text, index) => {
              acc[optionKeys[index]] = text;
              return acc;
            }, {});
            item.option = Object.fromEntries(
              Object.entries(item.option).reverse()
            );
          });
          console.log(this.questions);
        }
      });
    },
    // 选择
    selectAnswer(optionKey, optionText) {
      const { evaluatePersonnelCode } = this.$route.query;
      if (this.id) return;
      if (evaluatePersonnelCode) return;
      // **更新当前题目对应的答案**
      this.$set(this.selectedAnswers, this.currentIndex, {
        question: this.questions[this.currentIndex].question,
        point: optionKey,
        optionAnswer: optionText,
        questionId: this.questions[this.currentIndex].id,
        questionType: this.questions[this.currentIndex].questionType,
        // point: optionKey == 'A' ? 3 : optionKey == 'B' ? 2 : 1
      });
      console.log(this.selectedAnswers, "this.selectedAnswers");
      this.nextQuestion();

      if (this.selectedAnswers.length == this.questions.length) {
        this.disabled = false;
      }
    },
    // 下一题
    nextQuestion() {
      if (
        this.selectedAnswers[this.currentIndex] &&
        this.currentIndex < this.questions.length - 1
      ) {
        this.currentIndex++;
      }
    },
    // 上一题
    prevQuestion() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    // 下一步
    next() {
      this.$router.push({
        path: "/evaluation/object",
        query: {
          type: 2,
        },
      });
    },
    // 提交
    submit() {
      const obj = JSON.parse(sessionStorage.getItem("evaluationObject"));
      const params = {
        evaluatePersonnelCode: obj.evaluatePersonnelCode, // 考评对象工号
        evaluatorCode: obj.evaluatorCode, // 考评人工号
        managerCode: obj.managerCode, // 上级工号
        evaluateDescription: obj.evaluateDescription, // 描述
        deptName: obj.deptName, // 部门
        answerList: this.selectedAnswers, // 答题列表
        activityId: obj.activityId, // 活动标题
      };
      api.evaluateManageAdd(params).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success", // success error warning
            message: "提交成功",
            duration: 2000,
          });
          this.disabledNext = false;
          this.disabled = true;
          sessionStorage.removeItem("evaluationObject");
          // sessionStorage.removeItem("params");
        }
      });
      // if (this.id) {
      //   this.$router.push({
      //     path: "/evaluation/evaluationResult",
      //     query: { id: this.id },
      //   });
      // } else {
      //   const obj = JSON.parse(sessionStorage.getItem("evaluationObject"));
      //   const params = {
      //     evaluatePersonnelCode: obj.evaluatePersonnelCode, // 考评对象工号
      //     evaluatorCode: obj.evaluatorCode, // 考评人工号
      //     managerCode: obj.managerCode, // 上级工号
      //     evaluateDescription: obj.evaluateDescription,
      //     deptName: obj.deptName,
      //     answerList: this.selectedAnswers,
      //   };
      //   this.$router.push({
      //     path: "/evaluation/evaluationResult",
      //     query: { data: JSON.stringify(params) },
      //   });
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .fullbox,
  .footer {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .fullbox {
    width: 306px * $zoom;
    ::v-deep {
      .van-dropdown-item {
        width: 306px * $zoom !important;
        margin: auto;
      }
    }
  }
  .footer {
    width: 306px * $zoom;
  }
}
.mobile {
  width: 100%;
  display: flex;
  justify-content: center;
}
.fullbox {
  font-size: 14px * $zoom;
  position: relative;
  height: 100vh;
  padding-top: 30px;
  background: url("~@/assets/evaluation/bg2.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .goback {
    margin: 0 0 0 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .goback_box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding-right: 30px;
    }

    div {
      display: flex;
      align-items: center;
    }

    i {
      font-weight: bold;
      font-size: 48px;
      margin-right: 30px;
    }

    span {
      font-size: 34px;
      flex-shrink: 0;
    }

    .goback_search {
      margin-left: 20px;
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 80px;
      height: 80px;
      // width: 58vw;
      padding: 0 30px 0 10px;
      width: 260px;

      align-items: center;
      justify-content: space-between;

      ::v-deep .el-input {
        flex: 1;
        height: 100%;

        &__inner {
          height: 100%;
          border: none;
          font-size: 28px;
          border-radius: 80px;
        }
        .el-input__icon {
          line-height: 38px !important;
        }
      }

      i {
        font-size: 38px;
        margin-right: 10px !important;
      }
    }
  }
  .content {
    // background: #fff;
    border-radius: 50px 50px 0 0;
    flex: 1;
    padding: 30px;
    position: relative;
    margin-bottom: 120px;
    overflow: auto;
    .user-mes {
      .user {
        color: #121826;
        font-size: 32px;
        margin-bottom: 20px;
      }
      .mes {
        color: #666666;
        font-size: 26px;
        line-height: 40px;
      }
    }
    .quiz-container {
      width: 100%;
      background: #fafafa;
      padding: 30px;
      border-radius: 30px;
      margin-top: 30px;
      .title {
        font-size: 32px;
        color: #121826;
        font-weight: bold;
      }
      .msg {
        margin: 20px 0;
        color: #666666;
        font-size: 28px;
        line-height: 40px;
      }
      .option {
        display: flex;
        align-items: center;
        // justify-content: space-between;
        padding: 18px 30px;
        margin: 10px 0;
        border: 1px solid #ddd;
        border-radius: 30px;
        cursor: pointer;
        transition: background 0.3s;
        margin-bottom: 30px;
        position: relative;
      }

      .option.selected {
        background: #e0f5e5;
        border-color: #4caf50;
      }

      .option-letter {
        font-weight: bold;
        font-size: 30px;
        margin-top: 4px;
        margin-right: 30px;
      }

      .option-shu {
        width: 3px;
        height: 45px;
        background: #dbdada;
        margin-right: 80px;
      }

      .option-text {
        font-size: 30px;
      }

      .selected {
        .option-shu {
          background: #1fbe8a;
        }
      }

      .check-icon {
        width: 40px;
        height: 40px;
        position: absolute;
        right: 50px;
        top: 28%;
      }

      .button-group {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        button {
          width: 210px;
          height: 76px;
          border-radius: 20px;
          font-size: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-top: 12px;
        }
        .btn1 {
          border: 1px solid #1fbe8a;
          color: #1fbe8a;
          background: none;
        }
        .btn2 {
          background: #1fbe8a;
          color: #fff;
        }
        .is-disabled:nth-child(1) {
          border: 1px solid #96e1c8;
          color: #96e1c8;
          background: none;
        }
        .is-disabled:nth-child(2) {
          background: #96e1c8;
          color: #fff;
        }
      }

      button {
        padding: 8px 16px;
        border: none;
        border-radius: 5px;
        cursor: pointer;
      }

      button:disabled {
        background: #ddd;
        cursor: not-allowed;
      }
    }
  }
}
.footer {
  height: 120px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  button {
    width: 40%;
    height: 80px;
    border-radius: 15px;
  }

  .btn {
    width: 100%;
    .el-button {
      width: 90%;
      height: 90px;
      background: #1fbe8a;
      border-radius: 10px;
      font-size: 28px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      // position: absolute;
      // bottom: 50px;
      // left: 5%;
      margin: 30px auto;
    }
    .is-disabled {
      background: #97e1c9;
      border: 1px solid #97e1c9;
    }
  }
  .btn1 {
    margin-right: 5%;
    border: 1px solid #1fbe8a;
    color: #1fbe8a;
    background: #fff;
  }
  .btn2 {
    border: 1px solid #1fbe8a;
    background: #1fbe8a;
    color: #fff;
  }
  .is-disabled:nth-child(1) {
    border: 1px solid #96e1c8;
    color: #96e1c8;
    background: none;
  }
  .is-disabled:nth-child(2) {
    background: #96e1c8;
    border: 1px solid #96e1c8;
    color: #fff;
  }
}
</style>
